"use client";

import { isLpPath } from "@/lib/region";
import { usePublicPathname } from "@/lib/public-pathname";

export function HideOnLp({ children }: { children: React.ReactNode }) {
  const pathname = usePublicPathname();
  return isLpPath(pathname) ? null : <>{children}</>;
}

export function ShowOnLp({ children }: { children: React.ReactNode }) {
  const pathname = usePublicPathname();
  return isLpPath(pathname) ? <>{children}</> : null;
}
